import React from 'react'
import './Creator.css'
import proScreen from '../../assets/img/pro-screen.png'
import standardScreen from '../../assets/img/standard-screen.png'
import { ArrowBack } from '@material-ui/icons'

import CreatorPro from './CreatorPro/CreatorPro'
import CreatorStandard from './CreatorStandard/CreatorStandard'

export default class Creator extends React.Component {
  
  constructor(props){
    super(props)
    this.state = {
      selected_creator: 'none'
    }
  }

  render() {
    const { selected_creator } = this.state
    return (
      <>
        {
          selected_creator === 'none' ? (
            <div id="payge-type-selector">
              <div className="title-container">
                <ArrowBack className="icon" onClick={()=>window.open('/dashboard', '_self')}/>
                <span className="title">Choose a Payge Style</span>
              </div>
              <ul className="types">
                <li onClick={()=>this.setState({selected_creator: 'pro'})}>
                  <div className="text-container">
                    <span className="text-icon">P</span>
                    <span className="type-text">Pro</span>
                  </div>
                  <div className="img-container"><img src={proScreen} /></div>
                </li>
                <li onClick={()=>this.setState({selected_creator: 'standard'})}>
                  <div className="text-container">
                    <span className="text-icon">S</span>
                    <span className="type-text">Standard</span>
                  </div>
                  <div className="img-container"><img src={standardScreen} /></div>
                </li>
              </ul>
            </div>
          ) : selected_creator === "pro" ? (
            <CreatorPro />
          ) : selected_creator === "standard" ? (
            <CreatorStandard />
          ) : false
        }
      </>
    )
  }

}